module.exports = __webpack_public_path__ + "static/media/nav-main-logo.749daeaa.svg";